import React, { useEffect, useState } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { StyledEngineProvider } from "@mui/material";
import { MeshGradient, NavigationBar, Stepper } from "../../components";
import { RegisterContainer, RegisterStepsContainer } from "./Register.styles";
import { BasicInfo, Password, EmailVerification } from "../../components/Register";
import { DateOfBirth } from "../../components/Register/DateOfBirth/DateOfBirth";
import { Address } from "../../components/Register/Address/Address";
import { Accessibility } from "../../components/Register/Accessibility/Accessibility";
import { Gender } from "../../components/Register/Gender/Gender";
import { PhoneNumber } from "../../components/Register/PhoneNumber/PhoneNumber";
import { Success } from "../../components/Register/Success/Success";
import { useRegisterContext } from "../../contexts/RegisterContext";
import { PhoneNumberVerification } from "../../components/Register/PhoneNumberVerification/PhoneNumberVerification";
interface RegisterProps extends WithRouterProps {
    currentStep?: number;
    email: string;
    firstName: string;
}

const Register: React.FC<RegisterProps> = ({
    router,
    currentStep,
    email,
    firstName,
}) => {
    const { setRegisterInfo } = useRegisterContext();

    const stepSize = 10
    const [step, setStep] = useState(currentStep ? currentStep : 0);

    useEffect(() => {
        setRegisterInfo(prevRegisterInfo => ({
            ...prevRegisterInfo,
            user: {
                ...prevRegisterInfo.user,
                email: email ? email : ""
            }
        }))
    }, []);

    const nextStep = () => {
        setStep(step + 1);
    };

    const prevStep = () => {
        setStep(step - 1);
    };

    return (
        <StyledEngineProvider injectFirst>
            <NavigationBar
                showHomeIconOnMobile={step !== 0 && step !== stepSize - 1}
                showLoginButton={step === 0}
                showMenu={step === 0 || step === stepSize - 1}
                showRegisterButton={false}
            >
                {step !== 0 && step !== stepSize - 1 && <Stepper stepSize={stepSize} activeStepIndex={step} />}
            </NavigationBar>
            <RegisterContainer>
                <RegisterStepsContainer>
                    {step === 0 && <BasicInfo onNextButtonClick={nextStep} />}
                    {step === 1 && <EmailVerification onNextButtonClick={nextStep} onPrevButtonClick={prevStep} />}
                    {step === 2 && <Password onNextButtonClick={nextStep} />}
                    {step === 3 && <DateOfBirth onNextButtonClick={nextStep} onPrevButtonClick={prevStep} />}
                    {step === 4 && <Address onNextButtonClick={nextStep} onPrevButtonClick={prevStep} />}
                    {step === 5 && <Accessibility onNextButtonClick={nextStep} onPrevButtonClick={prevStep} />}
                    {step === 6 && <Gender onNextButtonClick={nextStep} onPrevButtonClick={prevStep} />}
                    {step === 7 && <PhoneNumber onNextButtonClick={nextStep} onPrevButtonClick={prevStep} />}
                    {step === 8 && <PhoneNumberVerification onNextButtonClick={nextStep} onPrevButtonClick={prevStep} />}
                    {step === 9 && <Success firstName={firstName}/>}
                </RegisterStepsContainer>
                <MeshGradient sx={{ position: 'fixed' }} colour={"teal-green"} position="bottom" size="low" />
            </RegisterContainer>
        </StyledEngineProvider>
    );
};

export default withRouter(Register);
